import { render, staticRenderFns } from "./statiColorsGestioneCamere.vue?vue&type=template&id=450c3bc6"
import script from "./statiColorsGestioneCamere.vue?vue&type=script&lang=js"
export * from "./statiColorsGestioneCamere.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports